import React, {useMemo} from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import {InstallmentItem} from '../InstallmentIntem';
import {Loading} from '../../../Interface/Loadings/Loading';
import {ParcelasDTO} from '../../../../dtos/ParcelasDTO';
import {useHelpers} from '../../../../context/helpers';

import {
  Container,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalSubtitle,
  InstallmentList,
  EmptyText,
} from './styles';

interface Props {
  showModal: boolean;
  onDismiss: () => void;
  isLoading: boolean;
  installments: ParcelasDTO[];
  voucher?: boolean | null;
  onSelect: (item: ParcelasDTO) => void;
  selectedInstallmentCount?: number | null;
}

export function InstallmentsModal({
  showModal,
  onDismiss,
  isLoading,
  installments,
  voucher,
  onSelect,
  selectedInstallmentCount,
}: Props) {
  const {formatNumberToLocaleAmount} = useHelpers();

  const availableInstallments = useMemo(
    () =>
      installments.filter(
        item => !voucher || item.installmentCount === 1,
      ),
    [installments, voucher],
  );

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Em quantas vezes?</ModalTitle>
          <ModalSubtitle>Selecione o parcelamento</ModalSubtitle>
        </ModalHeader>
        {isLoading ? (
          <Loading />
        ) : availableInstallments.length > 0 ? (
          <InstallmentList
            nestedScrollEnabled
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{paddingBottom: RFValue(10)}}>
            {availableInstallments.map((item, index) => (
              <InstallmentItem
                key={item.installmentCount}
                style={{
                  marginBottom:
                    index === availableInstallments.length - 1
                      ? 0
                      : RFValue(10),
                }}
                onPress={() => onSelect(item)}
                alert={item.aviso}
                installment={formatNumberToLocaleAmount(item.valorMes)}
                installmentCount={item.installmentCount.toString()}
                totalValue={formatNumberToLocaleAmount(item.valorCompraTaxa)}
                lastItem={index === availableInstallments.length - 1}
                selected={selectedInstallmentCount === item.installmentCount}
              />
            ))}
          </InstallmentList>
        ) : (
          <EmptyText>Parcelas indisponiveis no momento.</EmptyText>
        )}
      </ModalContent>
    </Container>
  );
}
